<template>
  <v-navigation-drawer v-model="costumizerDrawer" fixed temporary right>
    <v-card flat style="max-width: 500px">
      <v-card-title>
        <Icon size="28px" class="mr-2" name="paint" /> <h3 class="grey--text">Editar estilo:</h3>
        <v-spacer />
        <v-btn @click="toggleSidebars" small icon>
          <Icon size="24px" name="stats" />
        </v-btn>
      </v-card-title>

      <template v-if="isTable">
        <v-card-text>
          <v-checkbox
            v-model="style.borders"
            label="Mostrar Linhas"
          ></v-checkbox>
        </v-card-text>

        <v-expansion-panel >
          <v-expansion-panel-content v-if="style.borders">
            <template v-slot:header>
              <div class="square-holder">
                <span
                  class="mr-1 square"
                  :style="'background-color:' + style.borderColor"
                ></span>
                <span>Cor da Linha</span>
              </div>
            </template>
            <v-card>
              <v-card-text>
                <v-swatches
                  swatches="text-advanced"
                  show-fallback
                  v-model="style.borderColor"
                  inline
                />
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <template v-slot:header>
              <div class="square-holder">
                <span
                  class="mr-1 square"
                  :style="'background-color:' + style.colors[0]"
                ></span>
                <span>Cor da Tabela</span>
              </div>
            </template>
            <v-card>
              <v-card-text>
                <v-swatches
                  swatches="text-advanced"
                  show-fallback
                  v-model="style.colors[0]"
                  inline
                />
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>
      <template v-if="!isTable">
        <v-card-text>
          <v-checkbox
            v-model="monochrome"
            label="Monocromático"
          ></v-checkbox>
        </v-card-text>
        <div v-if="!monochrome" class="mx-3">
          <span class="caption grey--text left">Tema de cores:</span><br />
          <v-select
            v-model="selectedTheme"
            item-value="value"
            item-text="label"
            :items="themes"
            clearable
            solo
            class="thin-border"
          />
        </div>
        <v-expansion-panel v-if="monochrome">
          <v-expansion-panel-content >
            <template v-slot:header>
              <div class="square-holder">
                <span
                  class="mr-1 square"
                  :style="'background-color:' + style.colors[0]"
                ></span>
                <span>Cor do Gráfico</span>
              </div>
            </template>
            <v-card>
              <v-card-text>
                <v-swatches
                  swatches="text-advanced"
                  show-fallback
                  v-model="style.theme.monochrome.color"
                  inline
                />
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>

      <v-divider></v-divider>

      <div class="mx-2 mt-3">
        <v-btn 
        depressed
        round
        color="secondary"
        @click="costumizerDrawer = false"
        >Ver estatisticas</v-btn>
      </div>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
export default {
  components: {
    VSwatches,
  },
  data() {
    return {
      color: '#1CA085',
      colors: [],
      costumizerDrawer: false,
      colorCount: 0,
      isTable: false,
      monochrome: false,
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#d9d9d9'],
        theme: {
          monochrome: {
            enabled: true,
            color: '#d9d9d9',
            shadeTo: 'light',
            shadeIntensity: 0.65
          }
        }
      },
      themes: [
        {value: 'palette1' ,label: 'Palete 1'},
        {value: 'palette2' ,label: 'Palete 2'},
        {value: 'palette3' ,label: 'Palete 3'},
        {value: 'palette4' ,label: 'Palete 4'},
        {value: 'palette5' ,label: 'Palete 5'},
        {value: 'palette6' ,label: 'Palete 6'},
        {value: 'palette7' ,label: 'Palete 7'},
        {value: 'palette8' ,label: 'Palete 8'},
        {value: 'palette9' ,label: 'Palete 9'},
        {value: 'palette10' ,label: 'Palete 10'},
      ],
      selectedTheme: ''
    }
  },
  methods: {
    toggleSidebars() {
      this.costumizerDrawer = false
      this.$root.$emit('statsdrawer', true)
    }
  },
  mounted() {
    this.$root.$on('costumizerDrawer', (value) => {
      this.costumizerDrawer = value
    })
    this.$root.$on('isTable', (value) => {
      this.isTable = value
    })
  },
  created() {
    this.$root.$emit('selectedStyle', this.style)
  },
  watch: {
    style: {
      handler: function (newVal) {
        this.$root.$emit('selectedStyle', newVal)
      },
      deep: true,
    },
    selectedTheme(val) {
      this.style.theme = {
          palette: val,
          monochrome: {
            enabled: this.monochrome
          }
        }
      this.$root.$emit('selectedStyle', this.style)
    },
    'style.theme.monochrome.color'() {
      this.style.theme.monochrome.enabled = this.monochrome
      this.$root.$emit('selectedStyle', this.style)
    },
  },
}
</script>
<style>
.vue-swatches__fallback__wrapper {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}
.square-holder {
  display: flex;
  align-items: center;
}
.square {
  display: inline-block;
  height: 16px;
  width: 16px;
  border-radius: 5px;
}
</style>
